export const HEAREN_TRIGGERS = {
  DISCOVERY: {
    maxSessions: 2,
  },

  EVENING_RETURN: {
    preferredHours: [20, 21, 22, 23],
    minimumSessions: 3,
  },

  FATIGUE_SOFTENING: {
    shortSessionsThreshold: 5,
    repeatedInterruptions: true,
  },

  DEEP_IMMERSION: {
    longSessionMinutes: 30,
    lowInteraction: true,
  },

  READY_FOR_DEEPER: {
    minimumSessions: 3,
    minimumTotalMinutes: 60,
    testsCompleted: false,
  },
};